import {DateTimePicker, DateTimePickerProps} from "@mui/x-date-pickers";
import {Control, Controller, FieldValues, Path, useFormContext} from "react-hook-form";
import {useTranslation} from "react-i18next";
import {TextField} from "@mui/material";

type FormDatePickerProps<IFormValues extends FieldValues = FieldValues> =
    Omit<DateTimePickerProps<any, any>, "renderInput" | "value" | "onChange">
    & {
    name: Path<IFormValues>,
    control?: Control<IFormValues, any>
    label: string,
    readOnly?: boolean,
    required?: boolean
}

const FormDateTimePicker = <IFormValues extends FieldValues = FieldValues>({
                                                                               name,
                                                                               control,
                                                                               label,
                                                                               readOnly,
                                                                               required,
                                                                               ...props
                                                                           }: FormDatePickerProps<any>) => {
    // Use Form Context
    const formContext = useFormContext<IFormValues>();

    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    return (
        <Controller
            name={name}
            control={control ?? formContext.control}
            render={({field, fieldState}) =>
                <DateTimePicker
                    {...props}
                    value={field.value || "" || null}
                    onChange={(value) => {
                        field.onChange(value);
                    }}
                    showDaysOutsideCurrentMonth
                    views={["year", "month", "day", "hours", "minutes", "seconds"]}
                    disabled={readOnly}
                    inputFormat={"L LT" || props.inputFormat}
                    renderInput={(params) =>
                        <TextField
                            {...params}
                            required={required}
                            label={label}
                            onBlur={field.onBlur}
                            error={Boolean(fieldState.error)}
                            fullWidth
                            helperText={fieldState.error?.message}
                        />
                    }
                />
            }
        />
    );
};

export default FormDateTimePicker;